<mat-card appearance="outlined">
  <mat-card-header>
    <img mat-card-avatar class="platform-chat-icon" />
    <mat-card-title class="title">{{
      'INBOX.SETTINGS.PLATFORM_ASSISTANT.SETTINGS_CARD.TITLE' | translate
    }}</mat-card-title>
    <inbox-ai-badge></inbox-ai-badge>
    <div class="badge">
      <glxy-badge [color]="badgeState().color">{{ badgeState().name | translate }}</glxy-badge>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div class="statement">
      {{ 'INBOX.SETTINGS.PLATFORM_ASSISTANT.SETTINGS_CARD.DESCRIPTION' | translate }}
    </div>
    <div class="toggle-container">
      <mat-slide-toggle [checked]="platformAssistantEnabled()" (change)="handleToggleChange()"></mat-slide-toggle>
      <div class="toggle-description">
        {{ 'INBOX.SETTINGS.PLATFORM_ASSISTANT.SETTINGS_CARD.ENABLE' | translate }}
      </div>
    </div>
    <button mat-flat-button color="primary" [routerLink]="['platform-chat']">
      {{ 'INBOX.SETTINGS.PLATFORM_ASSISTANT.SETTINGS_CARD.GO_TO_CONFIGURATION' | translate }}
    </button>
  </mat-card-content>
</mat-card>
